export default "__VITE_ASSET__C$Ryr4cn__"